export default __webpack_public_path__ + "static/media/a047-icon4.60c09f53.png";